(function () {
  function initHero() {
    document.querySelectorAll('[data-tlp-about-hero]').forEach(function (hero) {
      requestAnimationFrame(function () {
        hero.classList.add('is-inview');
      });
    });
  }

  function initEvolutionSlider(root) {
    var stage = root.querySelector('[data-tlp-about-evolution-stage]');
    var after = root.querySelector('[data-tlp-about-evolution-after]');
    var handle = root.querySelector('[data-tlp-about-evolution-handle]');
    if (!stage || !after || !handle) return;

    var value = parseFloat(root.getAttribute('data-initial-position') || '50');
    var dragging = false;

    function setValue(next) {
      value = Math.max(2, Math.min(98, next));
      after.style.clipPath = 'inset(0 0 0 ' + value + '%)';
      handle.style.left = value + '%';
      handle.setAttribute('aria-valuenow', String(Math.round(value)));
    }

    function setFromClientX(clientX) {
      var rect = stage.getBoundingClientRect();
      setValue(((clientX - rect.left) / rect.width) * 100);
    }

    function eventX(event) {
      return event.touches ? event.touches[0].clientX : event.clientX;
    }

    stage.addEventListener('mousedown', function (event) {
      dragging = true;
      setFromClientX(eventX(event));
    });

    window.addEventListener('mousemove', function (event) {
      if (!dragging) return;
      setFromClientX(eventX(event));
    });

    window.addEventListener('mouseup', function () {
      dragging = false;
    });

    stage.addEventListener('touchstart', function (event) {
      dragging = true;
      setFromClientX(eventX(event));
    }, { passive: true });

    window.addEventListener('touchmove', function (event) {
      if (!dragging) return;
      setFromClientX(eventX(event));
    }, { passive: true });

    window.addEventListener('touchend', function () {
      dragging = false;
    });

    handle.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setValue(value - 2);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setValue(value + 2);
      }
    });

    setValue(value);
  }

  function init() {
    initHero();
    document.querySelectorAll('[data-tlp-about-evolution]').forEach(initEvolutionSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
